import "../style/popupMessage.css";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import * as actions from '../actions/micustomeractions'
const PopupMessage = () => {
    const dispatch = useDispatch();
    const state = useSelector(state => state.miCustomerSharedReducer);
    console.log(state.confirmPopup);

    return (
        state?.confirmPopup?.showConfirmPopup ?
            <div className="popup-overlay">
                <div className="popup-container" style={{
                    width: state?.confirmPopup?.isComp ? '90%' : '400px', textAlign: state?.confirmPopup?.isComp ? 'left' : 'center',
                    height: state?.confirmPopup?.isComp ? '80%' : '', overflowY: 'scroll'


                }}>
                    <h3 className="popup-title">{state?.confirmPopup?.title ?? 'Confirm'}</h3>
                    <p className="popup-message">{state?.confirmPopup?.message}</p>
                    {/* {state?.confirmPopup?.isComp && <>{state?.confirmPopup?.comp}</>} */}
                    {/* {message} */}
                    <div className="popup-icons">
                        {/* onClick={onYes} */}
                        {/* onClick={onNo} */}
                        {state?.confirmPopup?.showYes && <CheckCircleIcon style={{ height: '2em', width: '2em' }} className="popup-icon yes" onClick={() => dispatch(actions.confirmYes())} />}
                        {state?.confirmPopup?.showNo && <CancelIcon className="popup-icon no" style={{ height: '2em', width: '2em' }} onClick={() => dispatch(actions.confirmNo())} />}
                        {state?.confirmPopup?.showOk && <CheckCircleIcon className="popup-icon ok" style={{ height: '2em', width: '2em' }} onClick={() => dispatch(actions.confirmYes())} />}

                    </div>
                </div>
            </div >
            : <></>


    );
};

export default PopupMessage;

